<template>
    <header>
        <div class="header lang">
            <div class="header-top">
                <div class="inner">
                    <ul class="header-top__left">
                        <li>
                            <a href="https://mokdong.eumc.ac.kr/mongol" target="_blank" title="새 창 열림">Mokdong Hospital</a>
                        </li>
                        <li>
                            <a href="https://seoul.eumc.ac.kr/mongol" target="_blank" title="새 창 열림">Seoul Hospital</a>
                        </li>
                          <li>
                            <a href="https://wch.eumc.ac.kr/mongol" target="_blank" title="새 창 열림">Cancer Center For Women</a>
                        </li>
                        <!-- <li>
                            <a href="https://ewui.eumc.ac.kr/mongol/main.do" target="_blank" title="새 창 열림">Urology Institute</a>
                        </li> -->
                        <li v-if="$store.state.hospStore.hostNm !== '혈액암병원'">
                            <a href="https://blood.eumc.ac.kr/mn/main" target="_blank" title="새 창 열림">Blood Cancer Hospital</a>
                        </li>
                        <li v-if="$store.state.hospStore.hostNm !== '뇌혈관병원'">
                            <a href="https://ewhabrain.eumc.ac.kr/mn/main" target="_blank"  title="새 창 열림">Cerebrovascular Hospital</a>
                        </li>
                        <li v-if="$store.state.hospStore.hostNm !== '대동맥혈관병원'">
                            <a href="https://aorta.eumc.ac.kr/mn/main" target="_blank" title="새 창 열림" >Aorta and Vascular Hospital</a>
                        </li>
                        <li v-if="$store.state.hospStore.hostNm !== '엄마아기병원'">
                            <a href="https://mombaby.eumc.ac.kr/mn/main" target="_blank" title="새 창 열림">Mother & Baby Hospital</a>
                        </li>
                      
                    </ul>
                </div>
            </div>
            <div class="header-bottom">
                <div class="inner">
                    <h1 class="logo">
                        <a href="/mn/main">
                            <img src="@/assets/resource/icon/logo-lang--aorta.svg" alt=""  v-if="$store.state.hospStore.hostNm === '대동맥혈관병원'">
                            <img src="@/assets/resource/icon/logo-lang--ewhabrain.svg" alt=""  v-if="$store.state.hospStore.hostNm === '뇌혈관병원'">
                            <img src="@/assets/resource/icon/logo-lang--mombaby.svg" alt=""  v-if="$store.state.hospStore.hostNm === '엄마아기병원'">
                            <img src="@/assets/resource/icon/logo-lang--blood.svg" alt=""  v-if="$store.state.hospStore.hostNm === '혈액암병원'">
                        </a>
                    </h1>
                    <div class="header-menu-wrap" @mouseover="activateSubMenu" @mouseleave="deactivateSubMenu">
                        <ul class="header-menu" >
                            <template v-for="(menu, idx) in menuList" :key="menu">
                                <li :class="{'header-menu__item': true, 'active': selectedMenu.menuNo == menu.menuNo}" v-if="menu.depth == 1 && menu.gnbYn=='Y'" @mouseover="setParent(menu)">
                                    <component :is="menu.linkMethod.indexOf('blank') > -1 ? 'a' : 'router-link'" :href="menu.menuUrl" :to="menu.menuUrl" :target="menu.linkMethod" class="header-menu--main-link" @click="deactivateSubMenu">
                                        <h3>{{menu.menuName}}</h3>
                                    </component>                                    
                                </li>
                            </template>
                        </ul>
                        <slide-up-down :active="isSubMenuActive" :class="{ active: isSubMenuActive }" class="header-sub-menu">
                            <div class="inner">
                                <div class="header-sub-menu__left">
                                    <h3 class="title01">{{selectedMenu.menuName}}</h3>
        
                                    <!-- 센터/의료진 -->
                                    <template v-if="selectedMenu.menuNo == '1' || selectedMenu.menuNo == '22'">
                                        <h4 class="title02">의료진 검색</h4>
                                        <div class="header-sub-menu__left-search">
                                            <input type="text" placeholder="의료진을 검색해주세요." v-model="drName" @keyup.enter="goDoctor()">
                                            <a href="javascript:;" class="main-button c-main" @click="goDoctor">검색</a>
                                        </div>
                                    </template>

                                    <!-- 예약/발급 -->
                                    <template v-if="selectedMenu.menuNo == '2' || selectedMenu.menuNo == '23' ">
                                        <a href="https://www.medcerti.com/servlet/HPINDEX?COMMAND=ACTIVEX&GIWANNO=H20020" class="main-button c-sub" target="_blank">제증명서 온라인 발급 바로가기</a>
                                        <sub>
                                            온라인 제증명서 발급은 회원가입 없이 이용하실 수 있습니다.
                                            <br><br>
                                            환자 본인이 아닌 경우, 온라인 제증명서 발급은 불가 하므로 내원하셔서 발급받아 주시기 바랍니다.
                                        </sub>
                                    </template>

                                    <!-- 이용안내 -->
                                    <template v-if="selectedMenu.menuNo == '3' || selectedMenu.menuNo == '24'">
                                        <h4 class="title03">해피콜센터</h4>
                                        <h5 class="title01 call">1522-7000</h5>
                                        <h4 class="title03">진료시간</h4>
                                        <ul class="time">
                                            <li class="title">평일</li>
                                            <li class="text">
                                                08:30~12:00
                                                <br>
                                                13:00~17:00
                                            </li>
                                        </ul>
                                        <ul class="time">
                                            <li class="title">토요일</li>
                                            <li class="text">
                                                09:00~12:00
                                            </li>
                                        </ul>
                                    </template>

                                     <!-- 건강정보 -->
                                     <template v-if="selectedMenu.menuNo == '4' || selectedMenu.menuNo == '25'">
                                        <h4 class="title02">질환 및 검사 검색</h4>
                                        <div class="header-sub-menu__left-search">
                                            <input type="text" placeholder="검색어를 입력해주세요" v-model="title" @keyup.enter="goArticle()">
                                            <a href="javascript:;" class="main-button c-main" @click="goArticle()">검색</a>
                                        </div>
                                    </template>
        
                                    <!-- 병원소개 -->
                                    <template v-if="selectedMenu.menuNo == '5' || selectedMenu.menuNo == '26'">
                                        <div class="header-sub-menu__left-btn-wrap">
                                            <router-link class="header-sub-menu__left-btn" to="/kr/aorta_notice/list" v-if="$store.state.hospStore.hostNm === '대동맥혈관병원'" >
                                                <span class="img"></span>
                                                공지사항
                                            </router-link>
                                            <router-link class="header-sub-menu__left-btn" to="/kr/vie_notice/list" v-if="$store.state.hospStore.hostNm === '뇌혈관병원'" >
                                                <span class="img"></span>
                                                공지사항
                                            </router-link>
                                            <router-link class="header-sub-menu__left-btn" to="/kr/intro/directions">
                                                <span class="img"></span>
                                                오시는길
                                            </router-link>
                                            <a class="header-sub-menu__left-btn" href="https://www.eumc.ac.kr/fund/join/write.do" target="_blank">
                                                <span class="img"></span>
                                                후원하기
                                            </a>
                                        </div>
                                    </template>

                                    <template v-if="selectedMenu.menuNo == '52'">
                                        <sub>
                                            산모와 아기의 안전을 최우선으로 여기는 <br>
                                            이대엄마아기병원을 소개합니다.
                                        </sub>
                                        <h4 class="title02">의료진 검색</h4>
                                        <div class="header-sub-menu__left-search">
                                            <input type="text" placeholder="의료진을 검색해주세요." v-model="drName" @keyup.enter="goDoctor()">
                                            <a href="javascript:;" class="main-button c-main" @click="goDoctor">검색</a>
                                        </div>
                                    </template>

                                    <template v-if="selectedMenu.menuNo == '53'">
                                        <h4 class="title02">첫 진료 예약/ 알림톡 서비스</h4>
                                        <div class="header-sub-menu__left__reservation">
                                            <input type="text" placeholder="성함" v-model="name">
                                            <input type="text" placeholder="휴대전화번호" v-model="tel">
                                        </div>
                                        <div class="header-sub-menu__left__reservation-btn">
                                            <a href="javascript:;" class="main-button c-sub" @click="showPopup('firstVisible')">예약 신청</a>
                                            <a href="https://pf.kakao.com/_xdvyYT/chat?bot=true" target="_blank" class="main-button c-main">알림톡 서비스<br>(진료예약)</a>
                                        </div>
                                        <sub>
                                            전문 상담사가 첫 진료 환자 예약을 도와드립니다. <br>
                                            상담시간 : 평일 09:00 – 17:00 (토요일,공휴일 제외)
                                        </sub>
                                        <sub class="sub-bottom font-main">
                                            * 알림톡 서비스는 24시간 진료예약, 변경/취소, 증명서 발급이
                                            가능합니다.
                                        </sub>
                                    </template>

                                    <template v-if="selectedMenu.menuNo == '54'">
                                        <sub>
                                            이대엄마아기병원에서 제공드리는<br>
                                            여러 서비스를 안내해드립니다.
                                        </sub>
                                        <h4 class="title03">진료시간</h4>
                                        <ul class="time">
                                            <li class="title">평일</li>
                                            <li class="text">
                                                08:30~12:00 <br>
                                                13:00 ~ 17:00
                                            </li>
                                        </ul>
                                        <ul class="time">
                                            <li class="title">토요일</li>
                                            <li class="text">
                                                09:00 ~ 12:00
                                            </li>
                                        </ul>
                                        <h4 class="title03">해피콜센터</h4>
                                        <h5 class="title01 call">1522-7000</h5>
                                    </template>

                                    <!-- 행사신청 -->
                                    <template v-if="selectedMenu.menuNo == '55'">
                                        <sub>
                                            이대엄마아기병원에서 진행하는 <br>
                                            행사 내용 및 신청을 안내드립니다.
                                        </sub>
                                    </template>

                                    <!-- 후원안내 -->
                                    <template v-if="selectedMenu.menuNo == '56'">
                                        <sub>
                                            아기와 엄마의 이름으로 기부를 통해 <br>
                                            사랑과 마음을 전해주세요.
                                        </sub>
                                    </template>

                                    <!-- 엄마아기정보 -->
                                    <template v-if="selectedMenu.menuNo == '57'">
                                        <sub>
                                            이대엄마아기병원에서 분만과정 및 <br>
                                            산후 아기관리를 안내해드립니다.
                                        </sub>
                                    </template>
                                </div>

                                <ul class="header-menu-list">
                                    <!-- 센터/의료진 -->
                                     <template v-if="selectedMenu.menuNo == '343' || selectedMenu.menuNo == '344' 
                                        || selectedMenu.menuNo == '587' || selectedMenu.menuNo == '588'">
                                        <li class="header-menu-box" v-for="(menu, idx) in subList">
                                            <component :is="menu.linkMethod.indexOf('blank') > -1 ? 'a' : 'router-link'" :href="menu.menuUrl" :to="menu.menuUrl" :target="menu.linkMethod" @click="deactivateSubMenu">
                                                <div class="img">
                                                    <img :src="require(`@/assets/resource/icon/header-menu-box0${idx + 1}.svg`)" alt=""  v-if="$store.getters.getHost == 'H0006'">
                                                    <img :src="require(`@/assets/resource/icon/header-menu-box0${idx + 1}-brain.svg`)" alt="" v-else>
                                                </div>
                                                <h4 class="title03">{{menu.menuName}}</h4>
                                            </component>
                                        </li>
                                    </template>
        
                                    <template v-else>
                                        <li class="header-menu-item" v-for="(menu, idx) in subList" :key="menu">
                                            <h4 class="title03">
                                                <component :is="menu.linkMethod.indexOf('blank') > -1 ? 'a' : 'router-link'" :href="menu.menuUrl" :to="menu.menuUrl" :target="menu.linkMethod" @click="deactivateSubMenu">
                                                    {{menu.menuName}}
                                                </component>
                                            </h4>
                                            <ul class="header-sub-menu-list" v-if="menu.subList">
                                                <li class="header-sub-menu-item" v-for="sub in menu.subList" :key="sub">
                                                    <component :is="sub.linkMethod.indexOf('blank') > -1 ? 'a' : 'router-link'" :href="sub.menuUrl" :to="sub.menuUrl" :target="sub.linkMethod" @click="deactivateSubMenu">
                                                        {{sub.menuName}}
                                                    </component>
                                                </li>
                                            </ul>
                                        </li>
                                    </template>
                                </ul>
                                <!-- 엄마아기 - 진료예약 -->
                                <ul class="header-sub-menu__right"  v-if="selectedMenu.menuNo == '53'">
                                    <li class="header-sub-menu__right__item">
                                        <router-link to="/kr/mypage/result/out">
                                            <img src="/resource/icon/header-sub-menu__right__item01.svg" alt="">
                                            <h4 class="title">외래진료내역</h4>
                                        </router-link>
                                    </li>
                                    <li class="header-sub-menu__right__item">
                                        <router-link to="/kr/mypage/babyNote/babyNoteMain">
                                            <img src="/resource/icon/header-sub-menu__right__item02.svg" alt="">
                                            <h4 class="title">엄마아기수첩</h4>
                                        </router-link>
                                    </li>
                                </ul>
                                <!-- 엄마아기 - 후원안내 -->
                                <ul class="header-sub-menu__right"  v-if="selectedMenu.menuNo == '56'">
                                    <li class="header-sub-menu__right__item">
                                        <a href="https://www.eumc.ac.kr/fund/join/write.do" target="_blank" title="새창열림">
                                            <img src="/resource/icon/header-sub-menu__right__item03.svg" alt="">
                                            <h4 class="title">생애 첫 기부 참여하기</h4>
                                        </a>
                                    </li>
                                    <li class="header-sub-menu__right__item">
                                        <a href="https://www.eumc.ac.kr/fund/respect/sweetProgram.do" target="_blank" title="새창열림">
                                            <img src="/resource/icon/header-sub-menu__right__item04.svg" alt="">
                                            <h4 class="title">예우 프로그램</h4>
                                        </a>
                                    </li>
                                </ul>
                                <!-- 엄마아기 - 엄마아기정보 -->
                                <ul class="header-sub-menu__right"  v-if="selectedMenu.menuNo == '57'">
                                    <li class="header-sub-menu__right__item">
                                        <router-link to="/kr/mombaby/birth#05" class="header-sub-menu__right__item-btn">
                                            <img src="/resource/icon/header-sub-menu__right__item05.svg" alt="">
                                            <h4 class="title">입원안내</h4>
                                        </router-link>
                                    </li>
                                    <li class="header-sub-menu__right__item">
                                        <router-link to="/kr/mombaby/birth#02" class="header-sub-menu__right__item-btn">
                                            <img src="/resource/icon/header-sub-menu__right__item06.svg" alt="">
                                            <h4 class="title">자연분만</h4>
                                        </router-link>
                                    </li>
                                    <li class="header-sub-menu__right__item">
                                        <router-link to="/kr/mombaby/birth#03" class="header-sub-menu__right__item-btn">
                                            <img src="/resource/icon/header-sub-menu__right__item07.svg" alt="">
                                            <h4 class="title">제왕절개</h4>
                                        </router-link>
                                    </li>
                                </ul>
                            </div>
                        </slide-up-down>
                    </div>
                    <ul class="header-bottom__right">
                        <li>
                            <div class="header-select" ref="headerSelect">
                                <a href="javascript:;" class="header-select--btn" :class="{ active: isSelectActive }" @click.prevent="activeSelect">Mongolian</a>
                                <slide-up-down :active="isSelectActive" class="header-option">
                                    <div class="header-option-inner">
                                        <a href="/kr/main"  class="header-option--btn">Korean</a>
                                        <a href="/en/main"  class="header-option--btn">English</a>
                                        <a href="/ru/main"  class="header-option--btn">Russian</a>
                                        <a href="/ar/main"  class="header-option--btn">Arabic</a>
                                        <a href="/zh/main"  class="header-option--btn">Chinese</a>
                                    </div>
                                </slide-up-down>
                            </div>
                        </li>
                        <li>
                            <a href="" class="header-total-menu" @click.prevent="activemap"></a>
                        </li>
                    </ul>
                </div>
            </div>
            <slide-up-down :active="mapActive" class="site-map" :class="{ active: mapActive }">
                <div class="inner">
                    <ul class="site-map__list">
                        <template v-for="one in menuList">
                            <li class="site-map__item" v-if="one.depth == 1 && one.gnbYn == 'Y'">
                                <h3 class="title01">{{one.menuName}}</h3>
                                <ul class="site-map__deps2-list">
                                    <template v-for="two in menuList" :key="two">
                                        <li class="site-map__deps2-item" v-if="two.gnbYn == 'Y' && one.menuNo == two.parentMenuNo">
                                            <component :is="two.linkMethod.indexOf('blank') > -1 ? 'a' : 'router-link'" :href="two.menuUrl" :to="two.menuUrl" :target="two.linkMethod" class="title02" @click="activemap">
                                                {{two.menuName}}
                                            </component>
                                            <ul class="site-map__deps3-list">
                                                <template v-for="three in menuList" :key="three">
                                                    <li class="site-map__deps3-item" v-if="three.gnbYn == 'Y' && two.menuNo == three.parentMenuNo">
                                                        <a href="javascript:;" @click="activemap()" v-if="three.menuUrl.indexOf('/floorMap') > -1">
                                                            {{three.menuName}}
                                                        </a>
                                                        <component :is="three.linkMethod.indexOf('blank') > -1 ? 'a' : 'router-link'" :href="three.menuUrl" :to="three.menuUrl" :target="three.linkMethod" @click="activemap" v-else>
                                                            {{three.menuName}}
                                                        </component>
                                                    </li>
                                                </template>
                                            </ul>
                                        </li>
                                    </template>
                                </ul>
                            </li>
                        </template>
                    </ul>
                </div>
            </slide-up-down>
            <div class="popup" :class="{ active: isSearchActive }">
                <div class="total-search-wrap">
                    <a href="" class="total-search--close" @click.prevent="activesearch"></a>
                    <div class="total-search">
                        <input type="text" class="total-search--input" placeholder="검색어를 입력해주세요" v-model="searchKeyword" @keyup.enter="search(searchKeyword)">
                        <a href="" class="total-search--btn" @click.prevent="search(searchKeyword)"></a>
                    </div>
                    <ul class="total-search__list">
                        <li class="total-search__item" v-for="(hashtag, index) in hashTags" :key="index" >
                            <a href="javascript:;" @click="search(hashtag.codeName)">#{{hashtag.codeName}}</a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </header>

    <kr_FirstReservePopUp :popupVisible="firstVisible" :name="name" :tel="tel" @hide-popup="hidePopup" />
</template>

<script>
import SlideUpDown from 'vue-slide-up-down';

export default {
    components: {
        SlideUpDown,
    },
    data(){
        return {
            firstVisible: false,
            isSelectActive: false,
            isSearchActive: false,
            mapActive: false,
            isSubMenuActive: false,
            subList: [],
            selectedMenu: '',
            drName: '',
            title: '',

            hashTags: [],
            searchKeyword: '',

            name: '',
            tel: '',

        };
    },
    methods: {
        goDoctor(){
            if(!this.drName){
                alert('의료진명을 입력해주시길 바랍니다.')
                return
            }
            // if(this.drName.length < 2){
            //     alert('2글자 이상 입력해주시길 바랍니다.')
            //     return
            // }
            this.$router.push(`/kr/doctorList?drName=${this.drName}`)
        },
        goArticle(){
            if(!this.title){
                alert('질환 정보를 입력해주시길 바랍니다.')
                return
            }
            this.$router.push(`/kr/aorta_health_dic/list?title=${this.title}`)
        },
        setParent(menu){
            this.selectedMenu = menu
            const parentNo = menu.menuNo ? menu.menuNo : 1
            this.setMenuList(parentNo)
        },
        setMenuList(parentMenuNo){
            this.subList = this.menuList.filter(i => i.parentMenuNo == parentMenuNo && i.depth == '2' && i.gnbYn == 'Y')

            for(let i of this.subList){
                i.subList = this.menuList.filter(j => j.parentMenuNo == i.menuNo && j.gnbYn == 'Y')
            }
        },
        deleteCookie(name) {
            document.cookie = name + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
        },
        logout() {
            this.deleteCookie("access_token");
            this.$store.commit('setNaverYn', 'N')
            this.axios
                .get(this.api.member.logout)
                .then((res) => {
                    // console.log(res)
                })
                .catch(err => {
                    console.log(err);
                });
            this.$store.commit("setStatus", false);
            this.$store.commit('patInfoInit')
            location.reload();
        },
        activeSelect() {
            this.isSelectActive = !this.isSelectActive;
        },
        activesearch() {
            this.isSearchActive = !this.isSearchActive;
        },
        activemap() {
            this.mapActive = !this.mapActive;
        },
        activateSubMenu(index) {
            this.isSubMenuActive = true;
        },
        deactivateSubMenu() {
            this.isSubMenuActive = false;
            setTimeout(() => {
                if (!this.isSubMenuActive) {
                    this.selectedMenu = '';
                }
            }, 1000);
        },
        getHashTags() {
            this.axios.get(this.api.search.hashKeywords, {
                params: {
                    hospId: this.$store.getters.getHost
                }
            }).then(res => {
                this.hashTags = res.data.result
                if(this.hashTags && this.hashTags.length > 0){
                    this.hashTags = this.hashTags.filter(item => item.useYn == 'Y')
                }
            })
        },
        search(searchKeyword){
            this.$router.push('/kr/search?searchKeyword=' + searchKeyword)
            this.isSearchActive = false
        },
        closeFooterOptions(event) {
            const headerSelect = this.$refs.headerSelect;
            if (
                headerSelect && !headerSelect.contains(event.target)
            ) {
                this.isSelectActive = false;
            }
        },
        showPopup(param){
            if(!this.name || !this.tel){
                alert('성함과 휴대전화번호를 입력해주세요.')
                return
            }

            this[param] = true
        },
        hidePopup(param){
            this[param] = false
            this.name = ''
            this.tel = ''
        },
    },
    mounted() {
        this.getHashTags();
        document.addEventListener('click', this.closeFooterOptions);
    },
    beforeUnmount() {
        document.removeEventListener('click', this.closeFooterOptions);
    }
};
</script>